module.exports = __webpack_public_path__ + "zvetseni-prsou_67_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_67_before.jpg
// module id = 1362
// module chunks = 0